export default class RoleFilter {
  constructor (filterData) {
    this.id = filterData.id
    this.name = filterData.name
  }
}
